import { render, staticRenderFns } from "./buttonExatraction.vue?vue&type=template&id=38ef3e32&scoped=true&"
import script from "./buttonExatraction.vue?vue&type=script&lang=js&"
export * from "./buttonExatraction.vue?vue&type=script&lang=js&"
import style0 from "./buttonExatraction.vue?vue&type=style&index=0&id=38ef3e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ef3e32",
  null
  
)

export default component.exports